import React from 'react'

export const WizardContext = React.createContext({
  companyConfig: null,
  navigateToNext: () => {},
  navigateToPrevious: () => {},
})

const WizardContextProvider = (props) => {
  return (
    <WizardContext.Provider {...props}>{props.children}</WizardContext.Provider>
  )
}

export default WizardContextProvider
